import * as React from 'react';

import { IBuilder, ISeller } from '../../types/newbuildingsCompare';
import { PhoneButton } from '../../components/NewbuildingCallToAction/PhoneButton';
import { ShowPhonesModal } from '../../components/NewbuildingCallToAction/ShowPhonesModal';
import { trackOpenContacts } from '../NewbuildingCallButton/tracking';

export interface IShowPhonesProps {
  newbuildingId: number;
  url: string;
  builders: IBuilder[];
  sellers: ISeller[];
  onlyIcon?: boolean;
  buttonText?: string;
  showButtonIcon?: boolean;
  fullWidth?: boolean;
  onShowPhone?: () => void;
}

export const ShowPhones: React.FC<IShowPhonesProps> = ({
  newbuildingId,
  url,
  builders,
  sellers,
  onlyIcon,
  buttonText,
  showButtonIcon,
  fullWidth,
  onShowPhone,
}) => {
  const [isOpen, setOpen] = React.useState(false);

  const handleOpen = React.useCallback(() => {
    setOpen(true);
    trackOpenContacts({ newbuildingId, url });
  }, [newbuildingId, url]);

  const handleClose = React.useCallback(() => setOpen(false), []);

  return (
    <>
      <PhoneButton
        fullWidth={fullWidth}
        onlyIcon={onlyIcon}
        onClick={handleOpen}
        showIcon={showButtonIcon}
        text={buttonText}
      />
      <ShowPhonesModal
        builders={builders}
        isOpen={isOpen}
        newbuildingId={newbuildingId}
        onClose={handleClose}
        onShowPhone={onShowPhone}
        sellers={sellers}
        url={url}
      />
    </>
  );
};
